import type {
	PaymentReason,
	PaymentReasonType,
} from '~features/annals/enums/payment';

export enum PaymentType {
	Subscription = 'premium',
	BotSubscription = 'premium_dd',
}

export type TPaymentBaseConfig = {
	callback?: (isSuccess: boolean) => void;
	reason: PaymentReason;
	reasonType: PaymentReasonType;
	defaultPromocode?: string;
	botClientId?: number | string;
};

export type TGeneralPaywallContext = {
	isOpenPaymentForm: boolean;
	reason?: PaymentReason;
	reasonType?: PaymentReasonType;
	defaultPromocode?: string;
	botClientId?: number | string;
	openPaywall: (arg: TPaymentBaseConfig) => () => void;
};
